<div class="right-pad">
    <!-- Page Header -->
    <div class="flex-header mar-first-header">
        <div class="float-left">
            <div class="heading-flex">
                <h1>Roleplay Feedback</h1>
                <div class="tool-tip-wrapper">
                    <img class="icon-info-new" src="../../../assets/images/icon-info-new.svg" width="28" height="28" />
                    <!-- Tooltip content -->
                    <div class="roleplay-tooltip">
                        <div class="tool-tip-header">Scenario Details</div>
                        <div class="tool-tip-body">
                            <div class="tool-tip-block">
                                <label>Scenario Objective:</label>
                                <p>{{ scenario_objective }}</p>
                            </div>
                            <div class="tool-tip-flex-col">
                                <div class="tool-tip-block">
                                    <label>Scenario Name:</label>
                                    <p>{{ scenario_name }}</p>
                                </div>
                                <div class="tool-tip-block">
                                    <label>Created Time:</label>
                                    <p>{{ created_date }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p class="subtitle">Your report is now available for review and has also been sent to your email.</p>
            <p class="user-objective-text"><span class="user_objective">User Objective: </span>{{ user_objective }}</p>
        </div>
        <div class="float-right"></div>
    </div>

    <!-- Score Cards -->
    <div class="roleplay-scores-wrapper">
        @for(s of scores; track s; let i = $index) {
        <div class="roleplay-score-col" [ngClass]="getScoreColorClass(i)">
            <div class="roleplay-score-header">
                <div class="float-left">
                    @if (getScoreColorClass(i)) {
                    <img class="download-ico" src="../../../assets/icons/icon-score-{{getScoreColorClass(i)}}.svg"
                        width="48" height="48" alt="Score" title="Score" />
                    }
                </div>
                <div class="float-right">
                    <h2>{{ getFormattedScore(s) }}</h2>
                    <span title="{{ s.key }}">{{ s.key }}</span>
                </div>
            </div>
            <!-- <div class="roleplay-score-body">
                
            </div> -->
        </div>
        }
    </div>

    <!-- Feedback Tabs -->
    <div class="feedback-tab">
        <mat-tab-group [@.disabled]="true">

            <!-- Overall Feedback Tab -->
            <mat-tab label="Overall Feedback">
                <div class="scroll">
                    <div class="feedback-summary-section" *ngIf="os?.feedback || os?.objective_assessment">
                        <div class="feedback-summary-block" *ngIf="os?.feedback">
                            <h4>Overall Feedback</h4>
                            <p>{{ os?.feedback }}</p>
                        </div>
                        <div class="feedback-summary-block" *ngIf="os?.objective_assessment">
                            <h4>Objective Assessment</h4>
                            <p>{{ os?.objective_assessment }}</p>
                        </div>
                    </div>

                    <!-- Overall Card -->
                    <div class="card-wrapper" *ngIf="os?.topic">
                        <div class="card-header">
                            <div class="float-left">
                                {{ os?.topic }}
                            </div>
                            <div class="float-right">
                                @if(isNumericScore(os?.score, os?.max_score)){
                                <span class="scrores">Score {{ os?.score }}/{{ os?.max_score }}</span>
                                }
                                @else{
                                <span class="scrores">{{ os?.score }}</span>
                                }
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="strengths-section" *ngIf="os?.strengths?.length">
                                <h5 class="section-label strengths-label">Strengths</h5>
                                <ul>
                                    <li *ngFor="let s of os?.strengths">
                                        <span class="icon-wrap"><img src="../../../assets/images/icon-correct-round.svg"
                                                width="20" height="20" alt="Strength" /></span>
                                        <span class="item-text">{{ s }}</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="recommendations-section" *ngIf="os?.recommendations?.length">
                                <h5 class="section-label recommendations-label">Recommendations</h5>
                                <ul>
                                    <li *ngFor="let r of os?.recommendations">
                                        <span class="icon-wrap"><img src="../../../assets/images/icon-wrong-round.svg"
                                                width="20" height="20" alt="Recommendation" /></span>
                                        <span class="item-text">{{ r }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>

            <!-- Skill Tabs -->
            @for(skill of skills; track skill; let i = $index) {
            <mat-tab [label]="skill.topic">
                <div class="scroll">
                    <!-- Skill Card -->
                    <div class="card-wrapper" *ngIf="skill.strengths?.length || skill.recommendations?.length">
                        <div class="card-header">
                            <div class="float-left">
                                {{ skill.topic }}
                            </div>
                            <div class="float-right">
                                @if(isNumericScore(skill.score, skill.max_score)){
                                <span class="scrores">Score {{ skill.score }}/{{ skill.max_score }}</span>
                                }
                                @else{
                                <span class="scrores">{{ skill.score }}</span>
                                }
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="strengths-section" *ngIf="skill.strengths?.length">
                                <h5 class="section-label strengths-label">Strengths</h5>
                                <ul>
                                    <li *ngFor="let s of skill.strengths">
                                        <span class="icon-wrap"><img
                                                src="../../../assets/images/icon-correct-round.svg" width="20"
                                                height="20" alt="Strength" /></span>
                                        <span class="item-text">{{ s }}</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="recommendations-section" *ngIf="skill.recommendations?.length">
                                <h5 class="section-label recommendations-label">Recommendations</h5>
                                <ul>
                                    <li *ngFor="let r of skill.recommendations">
                                        <span class="icon-wrap"><img
                                                src="../../../assets/images/icon-wrong-round.svg" width="20"
                                                height="20" alt="Recommendation" /></span>
                                        <span class="item-text">{{ r }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Sub-Skill Cards -->
                    <div class="card-wrapper" *ngFor="let ss of skill.sub_skills">
                        <div class="card-header">
                            <div class="float-left">
                                {{ ss.topic }}
                            </div>
                            <div class="float-right">
                                <div class="like-dislike-wrapper">
                                    <span class="feedback-label">Was this summary accurate and helpful?</span>
                                    <img
                                        [src]="icons.like"
                                        (click)="giveFeedback('like', skill.topic, ss.topic)"
                                        class="like-button"
                                        alt="Like"
                                        title="Like" />
                                    <img
                                        [src]="icons.dislike"
                                        (click)="giveFeedback('dislike', skill.topic, ss.topic)"
                                        class="like-button"
                                        alt="Dislike"
                                        title="Dislike" />
                                </div>
                                <mat-icon class="info-icon"
                                    (click)="openSubSkillDescription(ss.topic, ss.evaluation_description)">info_outline</mat-icon>
                                @if(isNumericScore(ss?.score, ss?.max_score)){
                                <span class="scrores">Score {{ ss?.score }}/{{ ss?.max_score }}</span>
                                }
                                @else{
                                <span class="scrores">{{ ss?.score }}</span>
                                }
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="strengths-section" *ngIf="ss.strengths?.length">
                                <h5 class="section-label strengths-label">Strengths</h5>
                                <ul>
                                    <li *ngFor="let s of ss.strengths">
                                        <span class="icon-wrap"><img
                                                src="../../../assets/images/icon-correct-round.svg" width="20"
                                                height="20" alt="Strength" /></span>
                                        <span class="item-text">{{ s }}</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="recommendations-section" *ngIf="ss.recommendations?.length">
                                <h5 class="section-label recommendations-label">Recommendations</h5>
                                <ul>
                                    <li *ngFor="let r of ss.recommendations">
                                        <span class="icon-wrap"><img
                                                src="../../../assets/images/icon-wrong-round.svg" width="20"
                                                height="20" alt="Recommendation" /></span>
                                        <span class="item-text">{{ r }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
            }
        </mat-tab-group>
    </div>
</div>